<template>
   <div class="mb-0" style="overflow-y: scroll; height:400px;" v-if="calculationData">
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th style="width:15%">Datum</th>
                    <th style="width:40%">Ort</th>
                    <th style="width:10%" class="text-right">Passager</th>                
                    <th style="width:10%" class="text-right">Tjänstepassager</th>                
                    <th style="width:10%" class="text-right">Skattebeslut</th>                
                    <th style="width:15%" class="text-right">Förmån</th>              
                    <th>&nbsp;</th>  
                </tr>
            </thead>   
            <tbody>
                <tr v-for="entry in calculationData.Congestions" :key="entry.id">
                    <td style="width:15%">{{entry.Date | moment("YYYY-MM-DD")}}</td>
                    <td style="width:50%">{{entry.City}}</td>
                    <td style="width:10%" class="text-right">{{entry.Quantity}}</td>                 
                    <td style="width:10%" class="text-right">{{entry.BusinessPassages}}</td>                 
                    <td style="width:10%" class="text-right">{{entry.TaxDecision | currency}}</td>                 
                    <td style="width:15%" class="text-right">{{entry.CalculatedBenefit | currency}}</td>   
                    <td>&nbsp;</td>              
                </tr>       
            </tbody> 
            <tfoot>
                <tr>
                    <th colspan="6" class="text-right"><strong>Summa förmån {{sumBenefit | currency}}</strong></th>                
                </tr>
            </tfoot>
        </table>
    </div>    
</template>

<script>
export default {
    computed: {
        sumBenefit() {
            return this.calculationData.Congestions.reduce((sum, acc) => sum + acc.CalculatedBenefit, 0);
        }
    },
    props: {
        calculationData: null
    }  
}
</script>

<style>

</style>
